/**
 * Technical specifications supplied by George in the 15 October reply, aligned
 * with the previously reviewed supplier listing. Classification and endorsements
 * are not inferred. Educational copy is general context, not an AuraGlow trial.
 */
export const wavelengths = [
  {
    id: 'red', name: 'Red light', wavelength: '665', unit: 'nm',
    title: 'Fine lines. A closer look.',
    body: 'Red light is studied in skincare for the appearance of fine lines, wrinkles and rough texture.',
    detail: 'A visible red wavelength, paired with the mask’s near-infrared light.',
    color: '#FF7268', glow: '#B93135', background: '#311F25', invisible: false,
  },
  {
    id: 'blue', name: 'Blue light', wavelength: '460', unit: 'nm',
    title: 'A different light for breakouts.',
    body: 'Blue light is used in light-based acne care. It is distinct from the red and near-infrared wavelengths used in skin-aging research.',
    detail: '72 blue LEDs complement the mask’s 164 laser emitters.',
    color: '#94C5FF', glow: '#2D64D5', background: '#1C2942', invisible: false,
  },
  {
    id: 'near-infrared', name: 'Near-infrared', wavelength: '850', unit: 'nm',
    title: 'Beyond the visible spectrum.',
    body: 'Near-infrared light is invisible to the eye. It is studied alongside red light in skincare and photobiomodulation.',
    detail: 'The illustration uses a soft violet treatment to identify this invisible wavelength.',
    color: '#C7BAFF', glow: '#7159AB', background: '#292337', invisible: true,
  },
  {
    id: '1064', name: '1064 nm laser', wavelength: '1064', unit: 'nm',
    title: 'The fourth wavelength.',
    body: '1064 nm is the longest of the mask’s four wavelengths. It sits in the near-infrared spectrum, alongside 850 nm.',
    detail: 'It is invisible to the eye; the warm glow is an illustration of the selected wavelength.',
    color: '#EAC99B', glow: '#9C6E40', background: '#302923', invisible: true,
  },
] as const;
